import { FC, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Heading,
  Spinner,
  Text,
  TextField,
} from "@radix-ui/themes";
import FormErrorMessage from "@/components/FormErrorMessage/FormErrorMessage";
import RaffleUIItem from "./raffle.ui.item";
// import { useFindChallengeWinner } from "../hooks/useFindChallengeWinner";
import useGetRandomChallengeUser from "../hooks/useGetRandomChallengeUser";

const RaffleUITCL: FC = (): JSX.Element => {
  const [challengeSlug, setChallengeSlug] = useState("");
  const { data, loading, error, fetchData } =
    useGetRandomChallengeUser(challengeSlug);

  return (
    <Flex direction="column" gap="9">
      {/* Winner */}
      <Box>
        <Heading as="h2" size="5">
          Find a random winner
        </Heading>
        <Text as="p" size="2" mb="4">
          Click the button to find a random winner of the TCL Time Trial
          Challenge.
        </Text>
        {/* Challenge Slug Input */}
        <Flex direction="column" gap="4" mb="4">
          {" "}
          <Flex direction="column" gap="1">
            <Text as="label" size="2" weight="bold">
              Challenge slug
            </Text>
            <TextField.Root
              placeholder="Enter the challenge slug"
              type="text"
              value={challengeSlug}
              onChange={(e) => {
                setChallengeSlug(e.target.value);
              }}
            />
          </Flex>
          <Box>
            <Button onClick={() => fetchData()} disabled={loading}>
              {loading ? (
                <Spinner />
              ) : data ? (
                "Find en ny vinder"
              ) : (
                "Find en vinder"
              )}
            </Button>
          </Box>
          {error && <FormErrorMessage text={error.message} isVisible />}
          {data && <RaffleUIItem {...data} />}
        </Flex>
      </Box>
    </Flex>
  );
};

export default RaffleUITCL;
